import React from 'react';
import { COLORS, FONTS, inputStyle, labelStyle, cardStyle, handleInputFocus, handleInputBlur, primaryButtonStyle } from '../signup/signupStyles';

export const QuickProfile = ({ formData, onUpdate, onNext, opportunityCondition }) => {
  const canContinue = formData.firstName && formData.lastName && formData.email && formData.dateOfBirth;

  return (
    <div style={{
      minHeight: '80vh', backgroundColor: COLORS.bg, display: 'flex',
      alignItems: 'center', justifyContent: 'center', padding: '80px 20px 40px',
      fontFamily: FONTS.system
    }}>
      <style>{`
        @media (max-width: 480px) {
          .opp-profile-card { padding: 32px 24px !important; }
          .opp-name-row { flex-direction: column !important; }
        }
      `}</style>
      <div className="opp-profile-card" style={cardStyle}>
        {/* Progress */}
        <div style={{
          fontSize: '13px', fontWeight: '500', color: COLORS.muted,
          textAlign: 'center', marginBottom: '24px'
        }}>
          Step 1 of 3
        </div>

        <h2 style={{
          fontFamily: FONTS.serif, fontSize: '24px', fontWeight: '700',
          color: COLORS.text, margin: '0 0 8px', textAlign: 'center'
        }}>
          Create your profile
        </h2>
        <p style={{
          fontSize: '15px', color: COLORS.muted, margin: '0 0 28px',
          textAlign: 'center'
        }}>
          So we can match you with this {opportunityCondition} study
        </p>

        <div className="opp-name-row" style={{ display: 'flex', gap: '12px', marginBottom: '16px' }}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>First name*</label>
            <input type="text" value={formData.firstName}
              onChange={(e) => onUpdate({ firstName: e.target.value })}
              style={inputStyle} onFocus={handleInputFocus} onBlur={handleInputBlur} />
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Last name*</label>
            <input type="text" value={formData.lastName}
              onChange={(e) => onUpdate({ lastName: e.target.value })}
              style={inputStyle} onFocus={handleInputFocus} onBlur={handleInputBlur} />
          </div>
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={labelStyle}>Email*</label>
          <input type="email" value={formData.email}
            onChange={(e) => onUpdate({ email: e.target.value })}
            placeholder="your@email.com" style={inputStyle}
            onFocus={handleInputFocus} onBlur={handleInputBlur} />
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={labelStyle}>Date of birth*</label>
          <input type="date" value={formData.dateOfBirth}
            onChange={(e) => onUpdate({ dateOfBirth: e.target.value })}
            style={inputStyle} onFocus={handleInputFocus} onBlur={handleInputBlur} />
        </div>

        <div style={{ marginBottom: '28px' }}>
          <label style={labelStyle}>Phone (optional)</label>
          <input type="tel" value={formData.phone}
            onChange={(e) => onUpdate({ phone: e.target.value })}
            placeholder="(555) 123-4567" style={inputStyle}
            onFocus={handleInputFocus} onBlur={handleInputBlur} />
        </div>

        <button onClick={onNext} disabled={!canContinue} style={{
          ...primaryButtonStyle, width: '100%', padding: '16px 24px',
          opacity: canContinue ? 1 : 0.4,
          cursor: canContinue ? 'pointer' : 'not-allowed'
        }}>
          Continue to Screener
        </button>
      </div>
    </div>
  );
};
